<script lang="ts">
import { defineComponent } from 'vue'
import moment from 'moment'

export default defineComponent({
  name: "ExportModal",
  props: {
    groupDate: {
      type: String,
      required: false,
      default: ''
    }
  },
  methods: {
    confirmExport() {
      this.$emit('confirm-export')
      this.hideModal()
    },
    showModal() {
      this.$bvModal.show('withdrawal-analysis-export-modal')
    },
    hideModal() {
      this.$bvModal.hide('withdrawal-analysis-export-modal')
    }
  },
  computed: {
    formattedDate() {
      return this.groupDate
          ? moment(this.groupDate).format('DD/MM/YYYY')
          : 'Data não disponível'
    }
  }
})
</script>

<template>
  <b-modal
      id="withdrawal-analysis-export-modal"
      content-class="export-modal__content"
      header-class="export-modal__header"
      body-class="export-modal__body"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
  >
    <!-- Header -->
    <template #modal-header="{ close }">
      <button class="export-modal__close-btn" @click="close()" aria-label="Fechar modal">
        <img src="@src/assets/img/icons/x.svg" alt="ico-close" />
      </button>
    </template>

    <!-- Body Content -->
    <div class="export-modal__main">
      <div class="export-modal__icon">
        <img src="@src/assets/img/icons/downloadIcon.svg" alt="ico" />
      </div>

      <div class="export-modal__text">
        <h3 class="export-modal__title">Você está exportando os saques liberados</h3>
        <p class="export-modal__description">
          Apenas as análises com o status "Saque liberado" serão exportadas para o arquivo Excel.
          Certifique-se de que a análise foi realizada corretamente antes da exportação.
        </p>
      </div>
    </div>

    <!-- Footer Buttons -->
    <div class="export-modal__footer">
      <b-button class="export-modal__btn export-modal__btn--cancel" @click="hideModal">
        Cancelar ação
      </b-button>
      <b-button class="export-modal__btn export-modal__btn--confirm" @click="confirmExport">
        Exportar dados
      </b-button>
    </div>
  </b-modal>
</template>

<style lang="scss">
#withdrawal-analysis-export-modal {
  .export-modal {
    &__content {
      width: 507px;
      padding: 40px;
      border-radius: 20px;
      background: var(--Gray-white, #FFF);
    }

    &__header {
      border: none;
      padding: 0;
      display: flex;
      justify-content: flex-end;
      align-items: flex-end;
      min-height: auto;
    }

    &__body {
      padding: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    &__close-btn {
      background: none;
      border: none;
      padding: 0;
      cursor: pointer;

      svg {
        width: 40px;
        height: 40px;
      }
    }

    &__main {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 48px;
      margin-bottom: 48px;
      width: 100%;
    }

    &__icon {
      display: flex;
      width: 65px;
      height: 65px;
      padding: 21px 22px;
      justify-content: center;
      align-items: center;
      border-radius: 32.5px;
      background: var(--Gray-10, #F0F2F5);

      svg {
        stroke-width: 1.8px;
        stroke: var(--Gray-500, #000C0B);
        width: 15px;
        height: 28.636px;
      }
    }

    &__text {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 16px;
      text-align: center;
      max-width: 414px;
    }

    &__title {
      color: var(--Gray-500, #000C0B);
      font-size: 20px;
      font-weight: 700;
      line-height: 150%;
      margin: 0;
    }

    &__description,
    &__info {
      color: var(--Gray-200, #999E9D);
      font-size: 15px;
      font-weight: 400;
      line-height: 160%;
      margin: 0;
    }

    &__info {
      margin-top: 12px;
    }

    &__footer {
      display: flex;
      gap: 16px;
      width: 100%;
      padding-top: 24px;
      border-top: none;
    }

    &__btn {
      height: 55px;
      border-radius: 10px;
      font-size: 15px;
      font-weight: 600;
      display: flex;
      justify-content: center;
      align-items: center;
      flex: 1;

      &--cancel {
        background: var(--Gray-10, #F0F2F5);
        color: var(--Gray-500, #000C0B);
        border: none;
      }

      &--confirm {
        background: var(--Gray-500, #000C0B);
        color: var(--Gray-white, #FFF);
        border: none;
      }
    }
  }
}
</style>